module.exports = __webpack_public_path__ + "img/emoji_26.13e0b9dc.png";